import React, { useState, useEffect } from "react";
import * as C from "./FinalForm.styles";

const FinalForm = ({ onClose, isOpen, setOrderData, sendWhatsappMessage }) => {
    const [delivery, setDelivery] = useState(() => {
        const savedData = localStorage.getItem("delivery");
        return savedData ? savedData : ""
    });

    const [clientName, setClientName] = useState(() => {
        const savedData = localStorage.getItem("clientName");
        return savedData ? savedData : ""
    });

    const [paymentMethod, setPaymentMethod] = useState(() => {
        const savedData = localStorage.getItem("paymentMethod");
        return savedData ? savedData : ""
    });

    const [formData, setFormData] = useState(() => {
        const savedData = localStorage.getItem("finalFormData");
        return savedData ? JSON.parse(savedData) : {
            rua: "",
            bairro: "",
            numero: "",
            complemento: "",
            referencia: ""
        };
    });

    const [error, setError] = useState("");

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    useEffect(() => {
        localStorage.setItem("finalFormData", JSON.stringify(formData));
        localStorage.setItem("clientName", clientName);
        localStorage.setItem("paymentMethod", paymentMethod);
        localStorage.setItem("delivery", delivery);

        setOrderData({
            clientAddress: `${formData.rua}, ${formData.numero}, ${formData.bairro}${formData.complemento ? `, ${formData.complemento}` : ""}, Rondonópolis - MT.${formData.referencia ? ` Ponto de Referência: ${formData.referencia}` : ""}`,
            clientName: clientName,
            paymentMethod: paymentMethod,
            isDelivery: delivery
        });

    }, [formData, setOrderData, delivery, clientName, paymentMethod]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleClientName = (e) => {
        setClientName(e.target.value);
    };

    const handleConfirm = () => {
        if(clientName === ""){
            setError("O campo nome é obrigatório!");
            return;
        }

        if(paymentMethod === ""){
            setError("O campo forma de pagamento é obrigatório!");
            return;
        }

        if(delivery === ""){
            setError("O campo opção de entrega é obrigatório!");
            return;
        }

        if (delivery === "entrega") {
            if (!formData.rua || !formData.numero || !formData.bairro) {
                setError("Rua, número e bairro são obrigatórios!");
            } else {
                setError("");
                setOrderData({
                    clientAddress: `${formData.rua}, ${formData.numero}, ${formData.bairro}${formData.complemento ? `, ${formData.complemento}` : ""}, Rondonópolis - MT.${formData.referencia ? ` Ponto de Referência: ${formData.referencia}` : ""}`,
                    clientName: clientName,
                    paymentMethod: paymentMethod,
                    isDelivery: delivery
                });
                sendWhatsappMessage();
                onClose(false);
            }
        } else {
            setOrderData({
                clientName: clientName,
                paymentMethod: paymentMethod,
                isDelivery: delivery
            });
            setError("");
            sendWhatsappMessage();
            onClose(false);
        }
    };

    const handleClear = () => {
        setFormData({
            rua: "",
            bairro: "",
            numero: "",
            complemento: "",
            referencia: ""
        });
        setDelivery("");
        setClientName("");
        setPaymentMethod("");
        setOrderData("");
        localStorage.clear();
    };

    return (
        <C.Background isOpen={isOpen}>
            <C.FormContainer>
                <C.ButtonCloseForm onClick={() => onClose(false)}>x</C.ButtonCloseForm>
                <C.TitleForm>Dados Finais do Pedido</C.TitleForm>

                <C.Form>
                    <C.Field key="clientNameField">
                        <C.Input
                            type="text"
                            name="clientName"
                            value={clientName}
                            onChange={handleClientName}
                        />
                        <C.Label>Nome do Cliente</C.Label>
                    </C.Field>
                </C.Form>

                <C.Section>
                    <span>Forma de Pagamento</span>

                    <div>
                        <div>
                            <input
                                type="radio"
                                value="pix"
                                checked={paymentMethod === "pix"}
                                onChange={() => setPaymentMethod("pix")}
                            />
                            <span>Pix</span>
                        </div>
                        <div>
                            <input
                                type="radio"
                                value="dinheiro"
                                checked={paymentMethod === "dinheiro"}
                                onChange={() => setPaymentMethod("dinheiro")}
                            />
                            <span>Dinheiro</span>
                        </div>
                        <div>
                            <input
                                type="radio"
                                value="cartao"
                                checked={paymentMethod === "cartao"}
                                onChange={() => setPaymentMethod("cartao")}
                            />
                            <span>Cartão</span>
                        </div>
                    </div>
                </C.Section>

                <C.Section>
                    <span>Opção de entrega</span>

                    <div>
                        <div>
                            <input
                                type="radio"
                                value="entrega"
                                checked={delivery === "entrega"}
                                onChange={() => setDelivery("entrega")}
                            />
                            <span>Entrega</span>
                        </div>
                        <div>
                            <input
                                type="radio"
                                value="retirada"
                                checked={delivery === "retirada"}
                                onChange={() => setDelivery("retirada")}
                            />
                            <span>Retirada</span>
                        </div>
                    </div>
                </C.Section>

                {delivery === "entrega" &&
                    <C.Form>
                        {["rua", "bairro", "numero", "complemento", "referencia"].map((campo) => (
                            <C.Field key={campo}>
                                <C.Input
                                    type="text"
                                    name={campo}
                                    value={formData[campo]}
                                    onChange={handleChange}
                                    required={campo === "rua" || campo === "numero" || campo === "bairro"}
                                />
                                <C.Label>{campo.charAt(0).toUpperCase() + campo.slice(1)}</C.Label>
                            </C.Field>
                        ))}
                    </C.Form>
                }

                {error && <C.ErrorText>{error}</C.ErrorText>}
                <C.Buttons>
                    <C.Button onClick={handleConfirm}>Finalizar</C.Button>
                    <C.Button onClick={() => handleClear()}>Limpar</C.Button>
                    <C.Button onClick={() => onClose(false)}>Cancelar</C.Button>
                </C.Buttons>
            </C.FormContainer>
        </C.Background>)
};

export default FinalForm;